(() => {
  const dialog = document.getElementById('meg-cookie-preferences');
  if (!dialog || dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  const fields = dialog.querySelector('fieldset');
  const status = dialog.querySelector('[data-meg-cookie-status]');
  const purposes = ['preferences', 'analytics', 'marketing'];
  let opener;
  let api;
  let operation = 0;
  const message = key => { status.textContent = dialog.dataset[key]; };
  const read = () => {
    const values = api.currentVisitorConsent();
    purposes.forEach(key => { dialog.querySelector(`[name="${key}"]`).checked = values[key] === 'yes'; });
    return values;
  };
  const load = () => new Promise((resolve, reject) => {
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) return resolve(window.Shopify.customerPrivacy);
    if (typeof window.Shopify?.loadFeatures !== 'function') return reject(new Error('unavailable'));
    const timeout = setTimeout(() => reject(new Error('timeout')), 8000);
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      clearTimeout(timeout);
      if (error || !window.Shopify?.customerPrivacy?.currentVisitorConsent) reject(new Error('unavailable'));
      else resolve(window.Shopify.customerPrivacy);
    });
  });
  async function open(trigger) {
    if (dialog.open) return;
    opener = trigger;
    const current = ++operation;
    fields.disabled = true;
    purposes.forEach(key => { dialog.querySelector(`[name="${key}"]`).checked = false; });
    message('loading');
    dialog.showModal();
    try {
      api = await load();
      if (current !== operation || !dialog.open) return;
      read();
      fields.disabled = false;
      message('loaded');
    } catch (_) {
      if (current === operation && dialog.open) message('error');
    }
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target.closest('[data-meg-cookie-open],a[href="#shopifyReshowConsentBanner"]') : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(target);
  }, true);
  dialog.querySelector('[data-meg-cookie-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    ++operation;
    if (opener?.isConnected) opener.focus();
  });
  dialog.querySelectorAll('[data-meg-cookie-save]').forEach(button => button.addEventListener('click', () => {
    if (!api || fields.disabled) return;
    const choice = button.dataset.megCookieSave;
    const values = Object.fromEntries(purposes.map(key => [key, choice === 'accept' || (choice === 'selected' && dialog.querySelector(`[name="${key}"]`).checked)]));
    const current = ++operation;
    fields.disabled = true;
    message('saving');
    const fail = () => {
      if (current !== operation || !dialog.open) return;
      fields.disabled = false;
      message('error');
    };
    const timeout = setTimeout(fail, 8000);
    try {
      api.setTrackingConsent(values, () => {
        clearTimeout(timeout);
        if (current !== operation || !dialog.open) return;
        try {
          const saved = read();
          fields.disabled = false;
          message(purposes.every(key => saved[key] === (values[key] ? 'yes' : 'no')) ? 'saved' : 'error');
        } catch (_) { fail(); }
      });
    } catch (_) { clearTimeout(timeout); fail(); }
  }));
})();
